<template>
  <v-container>
    <div class="back-nav">
      <v-btn text :to="{ name: 'dashboard' }">
        <v-icon left>mdi-chevron-left</v-icon>
        Back
      </v-btn>
    </div>
    <v-row>
      <v-col cols="12">
        <pt-sheet>
          <v-row class="px-12">
            <v-col>
              <h1>Show Proof of Employee Monitoring</h1>
              <div class="body-desktop-medium-regular-16">
                The Centers for Medicare and Medicaid Services (CMS) requires
                healthcare vendors to monitor employees for exclusions monthly.
                VendorProof simplifies this process by enabling you to upload
                your compliance documentation or subscribe to our secure
                service, which automates employee monitoring and provides proof
                of compliance directly to your clients.
              </div>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="10" offset="1">
              <v-card class="get-started-card">
                <v-card-title>
                  <h4>Automate Your Employee Monitoring</h4>
                </v-card-title>
                <v-card-subtitle class="body-desktop-small-regular-14">
                  Automatically send your proof of monitoring each month to any
                  of your clients.
                </v-card-subtitle>
                <v-card-text>
                  <div class="body-desktop-medium-regular-16">
                    <span class="body-desktop-medium-bold-16"
                      >Starts at $25</span
                    >
                    /month
                  </div>

                  <v-btn
                    depressed
                    color="primary"
                    :to="{
                      name: 'employees'
                    }"
                    class="get-started-button mt-2 mb-4"
                    :block="$vuetify.breakpoint.xsOnly"
                    @click.native="
                      logEvent(
                        'Clicked button to upgrade to employee monitoring',
                        {
                          Location: location || 'Unknown'
                        }
                      )
                    "
                  >
                    Get Started
                  </v-btn>

                  <v-divider></v-divider>

                  <div class="body-desktop-small-bold-14 mt-4">
                    WHAT'S INCLUDED
                  </div>

                  <v-row dense>
                    <v-col cols="1">
                      <v-icon class="checkbox-color">mdi-check</v-icon>
                    </v-col>
                    <v-col class="body-desktop-small-regular-14">
                      <span class="body-desktop-medium-bold-16"
                        >Secure & Private:</span
                      >
                      Protect PII and ensure monthly OIG compliance
                    </v-col>
                  </v-row>
                  <v-row dense>
                    <v-col cols="1">
                      <v-icon class="checkbox-color">mdi-check</v-icon>
                    </v-col>
                    <v-col class="body-desktop-small-regular-14">
                      <span class="body-desktop-medium-bold-16"
                        >Affordable & Scalable:</span
                      >
                      Pricing that scales with your team
                    </v-col>
                  </v-row>
                  <v-row dense>
                    <v-col cols="1">
                      <v-icon class="checkbox-color">mdi-check</v-icon>
                    </v-col>
                    <v-col class="body-desktop-small-regular-14">
                      <span class="body-desktop-medium-bold-16"
                        >Automated & Compliant:</span
                      >
                      Auto-send compliance reports to clients on-demand or
                      monthly
                    </v-col>
                  </v-row>
                  <v-row dense>
                    <v-col cols="1">
                      <v-icon class="checkbox-color">mdi-check</v-icon>
                    </v-col>
                    <v-col class="body-desktop-small-regular-14">
                      <span class="body-desktop-medium-bold-16"
                        >Ecosystem Efficiency:</span
                      >
                      Streamline reporting and eliminate your risk
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>

              <h3 class="or-text">
                OR
              </h3>

              <v-card class="upload-card">
                <v-card-title>
                  <h4>Manually Upload Your Proof of Monitoring</h4>
                </v-card-title>
                <v-card-subtitle class="body-desktop-small-regular-14">
                  Already have 3rd party employee monitoring? Upload your proof
                  of monitoring and compliance now.
                </v-card-subtitle>
                <v-card-text>
                  <v-btn
                    depressed
                    :to="{
                      name: 'proofOfMonitoringSubmission',
                      params: {
                        customerId: this.customerId,
                        checklistItemId: this.checklistItemId
                      }
                    }"
                    class="upload-button mt-8 mb-4"
                    :block="$vuetify.breakpoint.xsOnly"
                    @click.native="
                      logEvent('Clicked button to upload proof of monitoring', {
                        Location: location || 'Unknown'
                      })
                    "
                  >
                    Upload Proof of Monitoring
                  </v-btn>

                  <v-divider></v-divider>

                  <div class="body-desktop-small-bold-14 mt-4">
                    WHAT'S INCLUDED
                  </div>

                  <v-row dense>
                    <v-col cols="1">
                      <v-icon class="checkbox-color">mdi-check</v-icon>
                    </v-col>
                    <v-col class="body-desktop-small-regular-14">
                      Your 3rd party proof of compliance is sent to your client
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </pt-sheet>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import PtSheet from "@/components/PtSheet.vue";

export default {
  name: "ShowProofOfEmployeeMonitoring",
  components: { PtSheet },
  props: ["checklistItemId", "customerId"]
};
</script>

<style lang="sass" scoped>
/** Header **
.back-nav .v-btn
  font-weight: normal
  color: $subtitle
  text-transform: none
  letter-spacing: 0
  font-size: 1rem

.back-nav .v-btn.v-size--x-large
  font-size: 22px
  line-height: 28px
  height: 64px
  padding: 0 50px

.product-bar
  height: 76px
  display: flex
  align-items: center

.get-started-card
  border: 1px solid $color-pt-royal-200
  background-color: $color-pt-royal-50
  display: inline-block
  max-width: 45%

.get-started-button
  width: 100%
  font-size: 16px

.checkbox-color
  color: #0EA5E9

.or-text
  text-align: center
  display: inline-block
  max-width: 8%
  min-width: 8%
  vertical-align: 600%

.upload-card
  border: 1px solid #D1D5DB
  background-color: white
  display: inline-block
  max-width: 45%
  vertical-align: top
  height: 100%

.upload-button
  width: 100%
  font-size: 16px
</style>
